<template>
  <div class="wrp">
    <section>
    <div class="tip">
      <p class="title">
        <img src="@/assets/img/huisuiyun.png" alt="hsy">
      </p>
      <p class="content">{{ getName }}</p>
      <a style="display: block;" href="https://ads.huisuiyun.com/729UpGqu4IHl" target="_blank">
        <img class="ads-img" src="https://ads.huisuiyun.com/banner.jpg" alt="">
      </a>
      <p class="message">帮企业打造数字化财税，结算，风控管理平台</p>
    </div>
    <div class="invoice" >
      <swiper :options="swiperOption" ref="mySwiper" @someSwiperEvent="swiperCallback" >
        <swiper-slide v-for="(item,i) in invoiceDetails" :key="i">
          <div class="img-wrp">
            <InvoiceCanvas v-if="item && item.id" @click.native="onShowCanvas(i)" :invoiceData="item" ref="invoiceCanvasRef" class="invoicePic"></InvoiceCanvas>
          </div>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination" v-show="isPagination"></div>
      </swiper>
    </div>
    <div class="btns">
      <div v-if="invoiceDetails && invoiceDetails[0] && invoiceDetails[0].pdfUrl" class="email down" @click="handleDown('pdf')">下载PDF</div>
      <div v-if="invoiceDetails && invoiceDetails[0] && invoiceDetails[0].ofdUrl" class="email down" @click="handleDown('ofd')">下载OFD</div>
      <div v-if="invoiceDetails && invoiceDetails[0] && invoiceDetails[0].xmlUrl" class="email down" @click="handleDown('xml')">下载XML</div>
      <div class="email" @click="handleSendEmail">发送邮箱</div>
    </div>
    </section>
    <van-popup
      v-model="show"
      @click-overlay="handleClose"
      :style="{ height: '20%', width: '90%' }"
    >
      <div class="popup">
        <div class="popup-top">
          <div></div>
          <div class="iconfont" @click="handleClose">{{'\ue607'}}</div>
        </div>
        <div class="emaliValue">
          <van-field v-model="emailValue" ref="emailRef" label="邮箱" placeholder="请输入邮箱" />
        </div>
        <div class="btnEmail" @click="sendEmail">确认发送</div>
      </div>
    </van-popup>
    <ImagePreview @onClose="onPreviewClose" :visible="previewShow" :img="img" />
  </div>
</template>

<script>
import InvoiceCanvas from '@components/InvoiceCanvas/index.vue'
import ImagePreview from '@components/ImagePreview'
import { Icon, SwipeItem, Swipe, Toast, Notify, Dialog, Field, Popup } from 'vant'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ConvertNumber, getQuery, deepCopy, download } from '@utils/basicUtil'
import { customerRequest } from '@services'
import { platformConfig } from '@assets/config'
export default {
  data () {
    return {
      company: '',
      money: '0',
      show: false,
      emailValue: '',
      phone: '',
      email: '',
      data: {
        id: '',
        purchaserName: '',
        purchaserTaxNo: '',
        purchaserBankNameAndAccount: '',
        sellerInvoiceDetails: [],
        sellerTelAndAdress: '',
        sellerBankNameAndAccount: ''
      },
      invoiceDetails: [],
      invoiceData: {},
      previewShow: false,
      img: '',
      swiperOption: {
        // 循环
        loop: true,
        // 滑动速度
        speed: 500,
        // delay:1000
        pagination: {
          el: '.swiper-pagination',
          // type: 'fraction'
          dynamicBullets: true
        }
      },
      isPagination: false
    }
  },
  async mounted () {
    // 解密id
    let queryObj = getQuery()
    let url = window.location.href
    console.log(queryObj)
    if (Object.keys(queryObj).includes('o')) {
      url = url.replace(window.location.origin, atob(decodeURIComponent(queryObj.o)))
      window.location.href = url.slice(0, url.indexOf('&o'))
    }
    this.id = queryObj.secret
    if (!this.id) { return }
    // 拿到数据
    await this.getInvoice()
    setTimeout(() => {
      this.data = deepCopy(this.data)
    }, 3000)
  },
  methods: {
    handleClose () {
      this.show = false
      this.emailValue = ''
    },
    async sendEmail () {
      let data = await customerRequest.noteLookProof.sendEmail({ email: this.emailValue, secret: this.id })
      console.log(data)
      this.show = false
      this.emailValue = ''
      Notify({ type: 'success', message: '发送成功' })
    },
    async handleDown (type) {
      Notify({ type: 'success', message: '正在下载...' })
      if (type === 'pdf') {
        download({ url: this.invoiceDetails[0].pdfUrl })
      } else if (type === 'xml') {
        download({ url: this.invoiceDetails[0].xmlUrl })
      } else {
        download({ url: this.invoiceDetails[0].ofdUrl })
      }
      // let data = await customerRequest.noteLookProof.getPdfUrl({ secret: this.id })
      // if (data.success) {
      //   Notify({ type: 'success', message: '正在下载...' })
      //   download({ url: data.result })
      // } else {
      //   Notify({ type: 'danger', message: data.message })
      // }
    },
    ConvertNumber (num) {
      return ConvertNumber(num)
    },
    handleSendEmail () {
      this.show = true
      setTimeout(() => {
        if (this.$refs.emailRef && this.$refs.emailRef.focus) {
          this.$refs.emailRef.focus()
        }
      }, 100)
    },
    onShowCanvas (index) {
      let src = this.$refs.invoiceCanvasRef[index].$refs.imgRef.children[0].src
      this.previewShow = true
      this.img = src
    },
    onImageChange (index) {
      this.index = index
    },
    async getInvoice () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      })
      // 根据id查询样张信息
      const data = await customerRequest.noteLookProof.getProofInfo({ secret: this.id })
      console.log(data)
      if (data.success) {
        Toast.clear({
          clearAll: true
        })
        this.invoiceDetails = deepCopy(data.result)
        this.invoiceDetails.forEach(v => {
          if (v) {
            if (v.details.length <= 8) {
              v.sellerInvoiceDetails = v.details
            } else if (v.details.length > 8) {
              v.sellerInvoiceDetails = v.details.slice(0, 8)
              v.sellerInvoiceDetails[7].goodsName = '...'
              v.sellerInvoiceDetails[7].shortName = '...'
              v.sellerInvoiceDetails[7].specification = '...'
              v.sellerInvoiceDetails[7].unit = '...'
              v.sellerInvoiceDetails[7].quantity = '...'
              v.sellerInvoiceDetails[7].unitPrice = '...'
              v.sellerInvoiceDetails[7].amount = '...'
              v.sellerInvoiceDetails[7].taxRate = '...'
              v.sellerInvoiceDetails[7].taxAmount = '...'
            }
          }
        })
        if (this.invoiceDetails.length > 1) {
          this.isPagination = true
        }
      } else {
        Toast.clear({
          clearAll: true
        })
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    onPreviewClose () {
      this.previewShow = false
    },
    swiperCallback (a, b, c) {

    }
  },
  computed: {
    getName () {
      return platformConfig.getAllName()
    }
  },
  components: {
    InvoiceCanvas,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [SwipeItem.name]: SwipeItem,
    [Swipe.name]: Swipe,
    [Toast.name]: Toast,
    [Field.name]: Field,
    [Popup.name]: Popup,
    swiper,
    swiperSlide,
    ImagePreview
  }
}
</script>

<style lang="less" scoped src="./style.less"/>
